export const QQ_PLOT_BUTTON_ID = 'QQPlotButton';
export const DEFAULT_INFO_ICON_TITLE = 'Please select a single model in order to view QQ plot.';
export const getUnavailableDatasetMessage = (datasetName) => `QQ plots are not available for the ${datasetName !== null && datasetName !== void 0 ? datasetName : 'current'} dataset.`;
